import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';

import { Button as UIButton } from '@rcg/ui-components';

export const Wrapper = styled.div`
  align-items: center;
  background-color: ${colors.functional.paleGrey};
  border-radius: ${({ borderRadius }) => borderRadius};
  display: inline-flex;
  height: 50px;
  padding: 5px;
  position: relative;
  width: 215px;

  @media (min-width: ${sizes.media.xxSmallMaxWidth}px) {
    width: 250px;
  }

  @media (min-width: ${sizes.media.mediumMinWidth}px) {
    width: 330px;
  }

  &.checked {
    background-color: ${colors.functional.paleGrey};
    border: none;
  }
`;

export const Button = styled(UIButton)`
  &.toggleButton {
    font-size: 16px;
    height: 39px;
    color: ${({ palette }) => palette.primary.dark};
    text-transform: capitalize;

    &.selected,
    &.selected:hover {
      background-color: ${({ palette }) => palette.primary.dark};
      color: ${({ palette }) => palette.primary.contrastText};
    }
  }

  &.toggleButton:hover {
    background-color: transparent;
  }
`;
